export const LEFT_COLUMN_WIDTH = 35;
export const RIGHT_COLUMN_WIDTH = 130;
